import { icalSyncQueryKeys as e } from "./icalSyncQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { icalSyncApi as n } from "@maat/api-ical-sync";
//#region src/icalSync/useUnhealthyIcalFeedsQuery.ts
var r = (r, i) => t({
	queryKey: e.unhealthyFeeds(r),
	queryFn: () => n.listUnhealthyFeeds(i?.limit).then((e) => e.feeds),
	enabled: !!r && (i?.enabled ?? !0)
});
//#endregion
export { r as useUnhealthyIcalFeedsQuery };
